import React from 'react';
import { func, string, bool } from 'prop-types';
import './styles.scss';

const CertificateDownload = ({ 
  value, 
  onDownload, 
  tooltipText = 'Generar certificado',
  disabled = false 
}) => {
  if (disabled || !value || value === 0) {
    return <span className="certificate-download-empty">-</span>;
  }

  return (
    <div className="certificate-download-wrapper">
      <span className="certificate-download-value">{value}</span>
      <i 
        className="bi bi-file-earmark-arrow-down-fill certificate-download-icon" 
        title={tooltipText}
        onClick={onDownload}
      />
    </div>
  );
};

CertificateDownload.propTypes = {
  value: string,
  onDownload: func.isRequired,
  tooltipText: string,
  disabled: bool
};

export default CertificateDownload;
